import React from 'react';
import * as PropTypes from 'prop-types';
import NumberInput from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { FIELD_TYPES } from 'utility/constants';
import TextInput from '..';
import TextAdornment from '../../Adornments/TextAdornment';
import { toDecimalNumber } from './DecimalNumber';

import {
  validatePriceNumber,
  negativesValidatePriceNumber,
} from 'components/Inputs/TextInput/NumericValidation/helpers';
import { withDecimalNumberValidation } from 'components/Inputs/TextInput/NumericValidation';

const PriceNumberTextInput = React.forwardRef(
  ({ startAdornment, currencySymbol, ...props }, ref) => {
    const { allowNegatives = true, value, disabled, variant } = props;
    const { t } = useTranslation();
    const isEmptyInput = isNaN(parseFloat(value));

    return (
      <TextInput
        ref={ref}
        // The empty, disabled state needs to allow "—" to appear, so we disabled the NumericInput
        Input={disabled && isEmptyInput ? undefined : NumberInput}
        thousandSeparator
        fixedDecimalScale
        decimalScale={2}
        startAdornment={
          disabled && isEmptyInput && variant === 'underline'
            ? null
            : startAdornment || <TextAdornment text={currencySymbol} />
        }
        {...props}
        validate={{
          ...(allowNegatives
            ? negativesValidatePriceNumber(t)
            : validatePriceNumber(t)),
          ...props.validate,
        }}
      />
    );
  }
);

export default PriceNumberTextInput;

PriceNumberTextInput.displayName = 'PriceNumberTextInput';
PriceNumberTextInput.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['outline', 'underline']),
  placeholder: PropTypes.string,
  startAdornment: PropTypes.element,
  currencySymbol: PropTypes.string,
  allowNegatives: PropTypes.bool,
};
PriceNumberTextInput.defaultProps = {
  disabled: false,
  variant: 'outline',
  placeholder: FIELD_TYPES.Money.placeholder,
  startAdornment: null,
  currencySymbol: '$',
  allowNegatives: true,
};

export const toPriceNumber = toDecimalNumber;

export const ValidatedPriceNumberTextInput =
  withDecimalNumberValidation(PriceNumberTextInput);
